<template>
  <div id="app-shell">
    <RouterView />
    <Alfred v-if="showAlfred" />
  </div>
</template>

<script>
import Alfred from '@/components/Alfred'

export default {
  components: {
    Alfred
  },
  computed: {
    showAlfred () {
      const routeName = this.$route && this.$route.name ? `${this.$route.name}` : ''
      const routePath = this.$route && this.$route.path ? `${this.$route.path}` : ''

      return !routeName.startsWith('authentication-') && routePath !== '/authentication'
    }
  }
}
</script>

<style lang="scss">
@import "mixins";
@import "theme";
@import "utilities";
</style>
